import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "sportavenue",
  favicon: '/sportavenue/sportavenue-favicon.jpg',
  companyName: "Sport Avenue",
  website: 'https://https://www.sport-avenue-pau.com/',
  notifyChannel: 'vel-sportavenue',
  htmlCustomCSS: "sportavenue.scss",
  onlyOneClub: true,
  header: {
    title: '',
    logo: '/sportavenue/sportavenue-logo-no-bg.png'
  },
  payByCard: "PAYLINE",
  useClubImgInClubList: false,
  plans: {
		...configDefault.plans,
    splitCounterAbo: true,
    withBanner: true,
		// useImg : 'withoutText', // img full size in the Choice card, not text
    // topOfferTitle: 'Offre du moment',
  },
  navigation: {
    ...configDefault.navigation,
    display: "line"
  },
  steps: {
    ...configDefault.steps,
    display: {
      showShortNames: false,
    },
    userForm: {
      ...configDefault.steps.userForm,
      displayFirstOffer: false,
      birthdateLabel: "Date de naissance",
			addressLabel: "Adresse",
    }
  },
  options: {
    title: "Choisissez vos options",
    message: "",
    nextLabel: "Suivant",
    desktopInlineBy3: true,
    useImg: true,
  },
  footer: {
    ...configDefault.footer,
    logo: '/sportavenue/sportavenue-logo-no-bg.png',
    textLine: null,
    cgv: {
      link: 'https://www.sport-avenue-pau.com/conditions-d-utilisation/',
      text: 'CGU'
    }
  }
};

export default config;
